import { render, staticRenderFns } from "./UnitView.vue?vue&type=template&id=870a21de&scoped=true&"
import script from "./UnitView.vue?vue&type=script&lang=js&"
export * from "./UnitView.vue?vue&type=script&lang=js&"
import style0 from "./UnitView.vue?vue&type=style&index=0&id=870a21de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870a21de",
  null
  
)

export default component.exports